import React, { useEffect, useState } from 'react';
import { useWindowDimensions } from '../../../utils/hooks';
import { clsx } from '../../../utils/utils';
import * as styles from './DiagonalLine.module.scss';

type DiagonalLineProps = {
  className?: string;
};

const DiagonalLine = ({ className }: DiagonalLineProps) => {
  const [lineContainerRef, setLineContainerRef] = useState<HTMLDivElement | null>(null);
  const [rerenderToggler, setRerenderToggler] = useState(0);

  // Hack to force a re-render when the window size changes
  useWindowDimensions();

  // Calculate the position and length of the line
  const containerWidth = lineContainerRef?.offsetWidth || 0;
  const containerHeight = lineContainerRef?.offsetHeight || 0;
  const length = Math.sqrt(Math.pow(containerWidth, 2) + Math.pow(containerHeight, 2));

  // Calculate the angle of the line to the horizontal
  const angle = Math.atan2(containerHeight, containerWidth) * (180 / Math.PI);

  // Force re-render every second of the first 3 seconds
  useEffect(() => {
    for (let i = 1; i <= 3; i++) {
      setTimeout(() => {
        setRerenderToggler(prev => prev + 1);
      }, i * 1000);
    }
  }, []);

  return (
    <div ref={setLineContainerRef} className={clsx(styles.lineContainer)}>
      <div
        className={clsx(className, styles.line)}
        style={{
          width: length,
          transform: angle ? `rotate(${angle}deg)` : undefined,
        }}
      ></div>
    </div>
  );
};

export default DiagonalLine;
